<template>
  <v-layout elevation-7>
    <v-flex>
      <v-card v-if="model != null">
        <v-parallax
          src="/static/images/track17-card.jpg"
          height="150"
        >
          <v-layout
            align-center
            column
            justify-center
            class="lightbox2"
          >
            <h1 class="display-1 mb-1 s-card-title font-effect-3d-float">Cainiao(China)</h1>
            <h4
              style="width:100%; padding-left:10px; padding-right:10px;"
              class="subheading s-card-subtitle text-xs-center">{{ model.baseInfo.latestTrackingDesc }}</h4>
          </v-layout>
        </v-parallax>

        <v-container
          id="grid"
          fluid
          grid-list-sm
          tag="section"
        >
          <v-layout wrap>
            <!--<v-flex class="subheading">상품정보</v-flex>-->
            <!--<v-flex xs12 order-xs0>-->
              <!--<v-layout column>-->
                <!--<v-flex>-->
                  <!--<v-card flat dark>-->
                    <!--<v-card-text>{{ "APPLE WATCH SERIES 3 (GPS 38MM) SPACE GRAY ALUMINIUM CASE WITH BLACK SPORT BAND" }}</v-card-text>-->
                  <!--</v-card>-->
                <!--</v-flex>-->
              <!--</v-layout>-->
            <!--</v-flex>-->
            <v-flex xs6 pl-2 pr-2>
              <label-text title="배송국가" :text="model.baseInfo.destCountry"></label-text>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs6 pl-2 pr-2>
              <label-text title="배송업체" :text="model.baseInfo.destCpCode+(model.baseInfo.destCpName === '' ? '': '('+model.baseInfo.destCpName+')')"></label-text>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs6 pl-2 pr-2>
              <label-text title="발송국가" :text="model.baseInfo.originCountry"></label-text>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs6 pl-2 pr-2>
              <label-text title="소요일" :text="model.baseInfo.daysNumber"></label-text>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs12 pl-2 pr-2>
              <label-text title="배송상태" :text="model.baseInfo.statusDesc"></label-text>
              <v-divider></v-divider>
            </v-flex>
          </v-layout>
        </v-container>
        <v-divider></v-divider>
        <v-layout
          column
          fill-height
        >
          <v-container v-if="!hasResult" fill-height fluid>
            <v-layout column class="text-xs-center">
              <v-flex  >
                <h1 v-if="!hasResult" class="title">조회된 데이터가 없습니다</h1>
              </v-flex>
            </v-layout>
          </v-container>

          <v-flex v-for="(detailList, index) in this.model" :key="index">
            <div v-if="detailList.length > 0">
<!--            <v-flex md5 pl-3 pt-3 pb-3>-->
<!--              <h3>* {{ section.countryName}}</h3>-->
<!--            </v-flex>-->
            <template v-for="(item, index) in detailList">
              <delivery-list-item v-bind:key="index"
                                  v-bind:title="item.desc == '' ? '-' : item.desc"
                                  v-bind:date="item.time"></delivery-list-item>
              <v-divider v-if="index + 1 < detailList.length" :key="`divider-${index}`"></v-divider>
            </template>
            </div>
          </v-flex>
        </v-layout>

      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import LabelText from '../LabelText'
import DeliveryListItem from '../DeliveryListItem'
export default {
  name: 'CainiaoCard',
  props: ['model'],
  components: {LabelText, DeliveryListItem},
  computed: {
    hasResult: function () {
      return this.model.detailList.length > 0
    }
  },
  methods: {
    statusDescr: function (status) {
      if (status === 'PICKEDUP') return 'Picked'
      if (status === 'SHIPPING') return 'In transit'
      if (status === 'DEPART_FROM_ORIGINAL_COUNTRY') return 'Origin leaving'
      if (status === 'ARRIVED_AT_DEST_COUNTRY') return 'Destination arrived'
      if (status === 'SIGNIN') return 'Delivered'
      if (status === 'WAIT4PICKUP') return 'Packed for picking'
      if (status === 'WAIT4SIGNIN') return 'Waiting for  picking'
      if (status === 'ORDER_NOT_EXISTS') return 'Not found'
      if (status === 'SIGNIN_EXC') return 'Unsuccessful delivery attempt'
      if (status === 'RETURN') return 'Parcel returned'
      // {statusDesc: "Shipping over time", status: "SHIPPING_OVER_TIME", className: ""}
      if (status === 'DEPART_FROM_ORIGINAL_COUNTRY_EXC') return 'Unsuccessful air delivery'
      if (status === 'ARRIVED_AT_DEST_COUNTRY_EXC') return 'Unsuccessful clearence'
      if (status === 'NOT_LAZADA_ORDER') return 'Not Found'
      if (status === 'OWS_WHCACCEPT') return 'Order received by warehouse'
      if (status === 'OWS_WHCOUTBOUND') return 'Left warehouse'
      if (status === 'OWS_CPACCEPT') return 'Shipment dispatched'
      if (status === 'OWS_DELIVERING') return 'In delivery'
      if (status === 'OWS_WAIT4SIGNIN') return 'Waiting self-take'
      if (status === 'OWS_DELIVER_FAIL') return 'Delivery failed'
      if (status === 'OWS_SIGNIN') return 'Delivered'
      if (status === 'LTL_CONSIGN') return 'Seller shipped'
      if (status === 'LTL_SHIPPING') return 'In transit'
      if (status === 'LTL_DELIVERING') return 'In delivery'
      if (status === 'LTL_WAIT4SIGNIN') return 'Waiting self-take'
      if (status === 'LTL_DELIVER_FAIL') return 'Delivery failed'
      if (status === 'LTL_SIGNIN') return 'Delivered'
      if (status === 'CWS_WHCACCEPT') return 'Order received by warehouse'
      if (status === 'CWS_OUTBOUND') return 'Departed warehouse'
      if (status === 'CWS_DEPART_FROM_ORIGINAL_COUNTRY') return 'Origin leaving'
      if (status === 'CWS_ARRIVED_AT_DEST_COUNTRY') return 'Destination arrived'
      if (status === 'CWS_DEPART_FROM_ORIGINAL_COUNTRY_EXC') return 'Unsuccessful air delivery'
      if (status === 'CWS_ARRIVED_AT_DEST_COUNTRY_EXC') return 'Unsuccessful clearence'
      if (status === 'CWS_WAIT4SIGNIN') return 'Waiting for  picking'
      if (status === 'CWS_SIGNIN_EXC') return 'Unsuccessful delivery attempt'
      if (status === 'CWS_SIGNIN') return 'Delivered'
      if (status === 'RETURNED_STAGE_START') return 'Return'
      if (status === 'RETURNED_STAGE_MIDDLE') return 'Return'
      if (status === 'RETURNED_STAGE_END') return 'Return'
      if (status === 'RDESTORYED_STAGE_START') return 'Parcel is destroyed'
      if (status === 'RDESTORYED_STAGE_MIDDLE') return 'Parcel is destroyed'
      if (status === 'RDESTORYED_STAGE_END') return 'Parcel is destroyed'
      // if (status === 'DEPART_FROM_ORIGINAL_COUNTRY') return '발송국 출발'
      // if (status === 'SIGNIN') return '도착'
      // if (status === 'ARRIVED_AT_DEST_COUNTRY') return '배송국 사무소 도착'
      // if (status === 'PICKEDUP') return '픽업'
      // if (status === 'WAIT4PICKUP') return '픽업대기'
      return status
    }
  }
}
</script>

<style scoped>
  .lightbox {
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.4) 0%, transparent 80px);
  }
  .lightbox2 {
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.4) 100%);
    padding-left: 0px!important;
  }
  .info-table {
    padding-top: 8px;
    padding-bottom: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/card/CainiaoCard.vue